var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'cheques')?_c('div',{staticClass:"m-t-10"},[_c('b-row',{staticClass:"align-items-center m-b-10",attrs:{"no-gutters":""}},[_c('b-col',[_c('nav-component')],1),_c('b-col',{staticClass:"text-right",attrs:{"cols":"auto"}},[_c('props-to-show',{attrs:{"model_name":"cheque"}})],1)],1),_c('list')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }